import type { BaseModalProps } from '../../../Modal/BaseModal.js'
import { BaseModal } from '../../../Modal/BaseModal.js'
import { XMarkIcon } from '@heroicons/react/24/outline'

export const SubmitInfoModal = (props: BaseModalProps) => {
  return (
    <BaseModal isOpen={props.isOpen} onClose={props.onClose}>
      <div className="modal-box p-6 overflow-hidden">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold">Your Order has been submitted</h3>
          <button className="btn btn-circle btn-ghost" onClick={() => props.onClose()}>
            <XMarkIcon />
            <span className="sr-only">Close</span>
          </button>
        </div>
        <div className="p-4 bg-base-100 space-y-3">
          <p className="text-base-content">
            You can track your order progress using the <span className="font-medium">Order Quality</span> button.
          </p>
          <p className="text-base-content">Spcfy will send you an email when further action is needed.</p>
          <p className="text-base-content">Preprocessing is rather quick depending on the amount of samples.</p>
          <p className="text-base-content">Postprocessing can take up to 24 hours.</p>
          <p className="text-base-content">
            You will be informed when your order is ready for postprocessing. In case of insufficient quality or errors, additional input
            might be required.
          </p>
          <p className="text-base-content">While waiting, consider adding additional metadata to your samples.</p>
        </div>
      </div>
    </BaseModal>
  )
}
